import { Checkbox } from '@/components/inputs';
import { CreateCampaignFormInput, CreateCampaignFormOutput } from '@/features/campaigns/components/CreateCampaign_v2/validation';
import { Audience } from '@/models/audiences';
import { Row } from '@tanstack/react-table';
import { FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

type AudienceNameColumnProps = {
  row: Row<Audience>;
};

export const AudienceNameColumn: FC<AudienceNameColumnProps> = ({ row }) => {
  const { setValue, watch } = useFormContext<CreateCampaignFormInput, unknown, CreateCampaignFormOutput>();
  const selectedAudienceId = watch('audience.id');

  const handleToggleRow = useCallback(() => {
    setValue('audience', row.original);
  }, [setValue, row]);

  return (
    <div className='flex items-center gap-3 ps-px'>
      <Checkbox
        checked={selectedAudienceId === row.id}
        onChange={handleToggleRow}
        onClick={(e) => e.stopPropagation()}
        className='form-radio !m-0 cursor-pointer !border-primary-border checked:!border-brand-500'
      />
      <p>{row.original.name}</p>
    </div>
  );
};
